import dayjs from 'dayjs';

// Цвет оповещений (warning) — единый для системы
export const WARNING_COLOR = '#faad14';
export const WARNING_BG    = '#fffbe6';

/** Дней до следующего дня рождения (0 = сегодня) */
export function daysUntilBirthday(birthDate: string): number {
  const today = dayjs().startOf('day');
  const bd = dayjs(birthDate);
  let next = dayjs(new Date(today.year(), bd.month(), bd.date())).startOf('day');
  if (next.diff(today, 'day') < 0) next = next.add(1, 'year');
  return next.diff(today, 'day');
}

export function pluralDays(n: number): string {
  if (n === 1) return 'день';
  if (n >= 2 && n <= 4) return 'дня';
  return 'дней';
}

/** true если дата рождения — сегодня */
export function isBirthdayToday(birthDate: string): boolean {
  return daysUntilBirthday(birthDate) === 0;
}

/** true если ДР в ближайшие N дней (включая сегодня) */
export function isBirthdaySoon(birthDate: string, within = 7): boolean {
  const d = daysUntilBirthday(birthDate);
  return d >= 0 && d <= within;
}
